import { useActivityShopUI } from 'hooks/useActivityShopUI';
import { useLocalization } from 'hooks/useLocalization';
import { useBusiness } from 'hooks/useBusiness';
import { formatNumberWithSpacesAndRounding } from 'utils/formatUtils';
import { Activity } from "interfaces/ActivityInterfaces";
import { ActivityInteractionData } from "interfaces/ActivityShopUIInterfaces";
import Grid from '@mui/material/Unstable_Grid2'; // Grid version 2
import { Box, Alert } from '@mui/material';
import SafeTypography from 'components/shared/safe/SafeTypography';
import AlertFullWidth from 'components/shared/AlertFullWidth';

interface ActivityGridItemBottomBarContentProps {
	activity: Activity;
	isHovered: boolean;
	totalPaxQty: number;
	activityInteractionData: ActivityInteractionData;
}

function ActivityGridItemBottomBarContent({ activity, isHovered, totalPaxQty, activityInteractionData }: ActivityGridItemBottomBarContentProps) {
	const { getStr } = useLocalization();
	const { activityAddons } = useBusiness();
	const { selectedCurrencyCode } = useActivityShopUI();
	const buttonColumnWidth = (activity.availableAsTourType.group && activity.availableAsTourType.private) ? 6 : 12;

	return (
		(activityInteractionData.isAdded && activityInteractionData.addedAs) ? (
			<AlertFullWidth sx={{ opacity: isHovered ? 0.9 : 0.8 }}>
				<Box
					sx={{
						display: 'flex',
						justifyContent: 'space-between',
					}}
				>
					<SafeTypography sx={{ fontSize: 13 }}>
						{getStr('Added')} ({getStr(activityInteractionData.addedAs)})
					</SafeTypography>
					<SafeTypography sx={{ fontSize: 13 }}>
						{
							activityInteractionData && `${formatNumberWithSpacesAndRounding(activityInteractionData.totalPrice[activityInteractionData.addedAs] / totalPaxQty)} ${selectedCurrencyCode} ${getStr('PER_PERSON_ABBREV')}`
						}
					</SafeTypography>
				</Box>
				{
					//Make array of activityInteractionData.addons[activityInteractionData.addedAs] which are isAdded === true
					activityInteractionData.addons[activityInteractionData.addedAs].filter((addonInteractionData) => addonInteractionData.isAdded).map((addedAddonInteractionData) => {
						const activityAddon = activityAddons.find((addon) => addon.id === addedAddonInteractionData.addonId);
						if (!activityAddon) {
							return null;
						}

						return (
							<Box
								sx={{
									display: 'flex',
									justifyContent: 'space-between',
								}}
								key={activity.id + '_' + activityAddon.id}
							>
								<SafeTypography sx={{ fontSize: 12 }}>
									+ {activityAddon.title}
								</SafeTypography>
								<SafeTypography sx={{ fontSize: 12 }}>
									{formatNumberWithSpacesAndRounding(addedAddonInteractionData.totalPrice / totalPaxQty)} {selectedCurrencyCode} {getStr('PER_PERSON_ABBREV')}
								</SafeTypography>
							</Box>
						);
					})
				}
			</AlertFullWidth>
		) : (
			<Grid container spacing={1} sx={{ width: '100%', paddingTop: '10px', paddingBottom: '10px' }}>
				{activity.availableAsTourType.group && (
					<Grid xs={buttonColumnWidth} sx={{ textAlign: 'center' }}>
						<div className="text-small">{getStr('GROUP')}</div>
						<div style={{ fontWeight: 'bold' }}>
							{
								activityInteractionData.totalPrice.group ? (
									<div>{formatNumberWithSpacesAndRounding(activityInteractionData.totalPrice.group / totalPaxQty)} {selectedCurrencyCode} {getStr('PER_PERSON_ABBREV')}</div>
								) : (
									<Alert severity="error" sx={{ justifyContent: 'center' }}>{getStr('Price_unset').toUpperCase()}</Alert>
								)
							}
						</div>
					</Grid>
				)}
				{activity.availableAsTourType.private && (
					<Grid xs={buttonColumnWidth} sx={{ textAlign: 'center' }}>
						<div className="text-small">{getStr('PRIVATE')}</div>
						<div style={{ fontWeight: 'bold' }}>
							{
								activityInteractionData.totalPrice.private ? (
									<div>{formatNumberWithSpacesAndRounding(activityInteractionData.totalPrice.private / totalPaxQty)} {selectedCurrencyCode} {getStr('PER_PERSON_ABBREV')}</div>
								) : (
									<Alert severity="error" sx={{ justifyContent: 'center' }}>{getStr('Price_unset').toUpperCase()}</Alert>
								)
							}
						</div>
					</Grid>
				)}
			</Grid>
		)
	);
}

export default ActivityGridItemBottomBarContent;